export enum NewClientModalTabs {
    CUSTOMER = 'Customer',
    CONTACT = 'Contact',
    FAMILY = 'Family',
    ADDITIONAL = 'Additional info',
    DISCOUNTS = 'Discounts',
}
